import { PRESERVE_ASPECT_RATIO_STORAGE_KEY } from 'features/streaming/constants';
import { selectPreserveAspectRatio } from 'features/streaming/streamingSlice';
import { call, select } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { safeLocalStorage } from 'utils/storage';

export function* togglePreserveAspectRatioSaga() {
  const preserveAspectRatio: boolean = yield select(selectPreserveAspectRatio);

  safeLocalStorage.setItem(PRESERVE_ASPECT_RATIO_STORAGE_KEY, `${preserveAspectRatio}`);

  yield call(SignalingSocket.send, {
    event: 'adjustAspectRatio',
    data: {
      keep: preserveAspectRatio,
    },
  });
}
